<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>抖音核销列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox">
      <div class="conentTitle">
        <el-input placeholder="核销码" v-model="data.origin_code" />
        <el-input placeholder="订单号" v-model="data.order_id" />
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-button  type="primary" @click="btns">查询</el-button>
        <el-button  type="primary" @click="reportbtns">去导出</el-button>
      </div>
      <span class="dyspan">
        注意:本订单可作参考，具体对账以抖音报表为准
      </span>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          v-loading="loading"
          style="width: 100%"
        >
          <el-table-column prop="sku_id" label="商品ID"></el-table-column>
          <el-table-column prop="sku_name" label="产品名称" ></el-table-column>
          <el-table-column prop="order_id" label="订单号"></el-table-column>
          <el-table-column prop="origin_code" label="核销码"></el-table-column>
          <el-table-column prop="verifySource" label="验票来源"></el-table-column>
          <el-table-column prop="verifyPerson" label="验票人"></el-table-column>
          <el-table-column prop="created_at" label="核销时间"></el-table-column>
          </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" @current-change="currenchange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
  </div>
</template>
<script>
import { douyinCodeVerifyRecordList } from '@/request/scenic.js'
export default {
  data(){
    return{
      data:{
        start_time:'',
        end_time:'',
        origin_code:'',
        order_id:'',
        page_size:10,
        page:1,
        token:window.sessionStorage.getItem('Token'),
      },
      total:0,
      tableData:[],
      value1:'',
      loading:true
    }
  },
  created(){
    this.getList()
  },
  methods:{
    reportbtns(){
      this.$router.push({
        name:'report',
        params:{
            id:2,
            data:'',
            index:'55'
        }
      })
    },
    btns(){
      if(this.value1){
        this.data.start_time = this.value1[0]
        this.data.end_time = this.value1[1]
      }else{
        this.data.start_time = ''
        this.data.end_time = ''
      }
      this.loading = true
      this.data.page = 1
      this.getList()
    },
    currenchange(e){
      this.loading = true
      this.data.page = e
      this.getList()
    },
    getList(){
      douyinCodeVerifyRecordList(this.data).then(res=>{
        console.log(res)
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data.map(item => {
            // 处理验票人字段
            let verifyPerson = ''
            let verifySource = ''
            if (item.type == 2) {
              verifyPerson = item.user_name || ''
              verifySource = '小程序'
            }else if(item.type == 1){
              // 处理验票来源字段
              let fromText = ''
              if (item.from == 2) {
                fromText = '内管收银'
              } else if (item.from == 3) {
                fromText = '自助机'
              } else if (item.from == 4) {
                fromText = '闸机'
              } else {
                fromText = item.from || ''
              }
              verifySource = fromText
              if (item.client) {
                verifyPerson = item.client
              }
            }
            
           
            
            return {
              ...item,
              verifyPerson,
              verifySource
            }
          })
          console.log("-------------------->",this.tableData)
          this.total =res.data.result.total
          this.loading = false
        }
      })
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
}
</script>
<style lang='less' scoped>
/deep/.el-card__body {
  padding: 0 2rem;
}
.conentBox {
  margin-top: 17px;
  .conentTitle {
    margin: 2rem 0;
    display: flex;
    flex-wrap: wrap;
    .el-input,
    .el-select {
      width: 22rem;
      margin-right: 1rem;
      margin-bottom: 1rem;
    }
    .el-date-editor {
      width: 38rem;
      margin-bottom: 1rem;
      margin-right: 1rem;
    }
    .el-button {
      margin-bottom: 1rem;
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
    }
    .btnMar {
      margin: 0 1rem 10 2rem;
    }
  }
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}

/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 2rem 2rem;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 2rem;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 2rem;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 2rem 0;
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
.mask {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mask img{
  width: 34.5rem;
  height: 34.5rem;

}
.orderContent{
  display: flex;
  flex-direction: column;
}

.orderContent span{
  text-align: left;
  color: #000000;
  font-size: 1.4rem;
  height: 2.6rem;
  &:nth-child(1){
    color: #468BC8;
    cursor: pointer;
  }
}
/deep/ .el-table th, /deep/.el-table td{
  text-align:left !important;
}
/deep/ .el-dialog__header{
  text-align: center;
}
/deep/.el-collapse-item__header{
  height:11rem;
}
.tkBtns{
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  ::v-deep .el-button{
    width: 20rem;
  }
}
.dyspan{
  display: block;
  margin-bottom: 2rem;
  color: red;
  font-size: 1.6rem;
}
</style>